import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled(Form)`
  .bd-add-new-mod {
    border: 1px solid #ff6900;
    p {
      color: #ff6900;
    }
  }

  .input-height {
    height: 25px;
  }

  input::placeholder {
    color: #d8d8d8;
  }
`;
